import { injectGlobal } from 'emotion';
import fontFiles from './font-files';

export default injectGlobal`
  // Extra light
  @font-face {
    font-family: 'VerlagNormal';
    font-style: normal;
    font-weight: 100;
    src: url(${fontFiles.VerlagXLight}) format('opentype');
  }

  // Extra light italic
  @font-face {
    font-family: 'VerlagNormal';
    font-style: italic;
    font-weight: 100;
    src: url(${fontFiles.VerlagXLightItalic}) format('opentype');
  }

  // Light
  @font-face {
    font-family: 'VerlagNormal';
    font-style: normal;
    font-weight: 200;
    src: url(${fontFiles.VerlagLight}) format('opentype');
  }

  // Light italic
  @font-face {
    font-family: 'VerlagNormal';
    font-style: italic;
    font-weight: 200;
    src: url(${fontFiles.VerlagLightItalic}) format('opentype');
  }

  // Book
  @font-face {
    font-family: 'VerlagNormal';
    font-style: normal;
    font-weight: 400;
    src: url(${fontFiles.VerlagBook}) format('opentype');
  }

  // Book italic
  @font-face {
    font-family: 'VerlagNormal';
    font-style: italic;
    font-weight: 400;
    src: url(${fontFiles.VerlagBookItalic}) format('opentype');
  }

  // Bold
  @font-face {
    font-family: 'VerlagNormal';
    font-style: normal;
    font-weight: 600;
    src: url(${fontFiles.VerlagBold}) format('opentype');
  }

  // Bold italic
  @font-face {
    font-family: 'VerlagNormal';
    font-style: italic;
    font-weight: 600;
    src: url(${fontFiles.VerlagBoldItalic}) format('opentype');
  }

  // Black
  @font-face {
    font-family: 'VerlagNormal';
    font-style: normal;
    font-weight: 700;
    src: url(${fontFiles.VerlagBlack}) format('opentype');
  }

  // Black italic
  @font-face {
    font-family: 'VerlagNormal';
    font-style: italic;
    font-weight: 700;
    src: url(${fontFiles.VerlagBlackItalic}) format('opentype');
  }
`;



// WEBPACK FOOTER //
// ./src/fonts/fonts.js